import { pluralizeWord } from '@doveit/hammer';

export default function getSearchResultTitle(resultsCount: number, completeCount: number) {
  const complete = completeCount >= 1 ? ` (${resultsCount > 1 ? `${completeCount} ` : ''}${pluralizeWord('complet', 'o', 'i', completeCount)})` : '';

  return `${resultsCount} ${pluralizeWord('contatt', 'o', 'i', resultsCount)} ${pluralizeWord('trovat', 'o', 'i', resultsCount)}${complete}`;
}
